import React, { useContext } from "react";
import { WatchQueryFetchPolicy } from "@apollo/client";
import { useModal } from "react-modal-hook";
import { RESOURCE_NAME } from "common/authorization";
import { useLogsQuery } from "../../generated/graphql";
import { AuthContext } from "../Authorization/AuthContext";
import { FlexRow } from "../Common/__styles__/Layout";
import { Button } from "../Common/Button";
import Modal from "../Common/Modal";
import ExportLogs from "./ExportLogs";
import Table from "./Table";

export default (
  { fetchPolicy }: { fetchPolicy: WatchQueryFetchPolicy } = {
    fetchPolicy: "cache-and-network",
  },
) => {
  const { data, loading, error, refetch } = useLogsQuery({
    fetchPolicy,
  });

  const { authorized } = useContext(AuthContext);

  const [showModal, hideModal] = useModal(() => (
    <Modal onRequestClose={hideModal}>
      <ExportLogs closeModal={hideModal} />
    </Modal>
  ));

  if (error) return null;

  const canExportLogs = authorized({
    resource: RESOURCE_NAME.INFORMATION_REQUEST,
    permission: "export",
  });

  const actions = (
    <FlexRow gap="s" style={{ justifyContent: "flex-end", width: "100%" }}>
      <Button
        onClick={showModal}
        size="small"
        styleVariant="outlineLight"
        disabled={!canExportLogs}
        aria-label="Export Logs"
        leftIconName="download"
      >
        Export
      </Button>
    </FlexRow>
  );

  return (
    <Table
      tableActions={actions}
      data={data?.informationRequests ?? []}
      loading={loading}
      onUpdate={refetch}
    />
  );
};
